import Cookies from "js-cookie";

//* IS Checked Cookies
export const isTokenValid = () => {
  const accessToken = Cookies.get("accessToken");
  if (accessToken) return true;
  return false;
};
export const isCartValid = () => {
  const cart = Cookies.get("cart");
  if (cart) return true;
  return false;
};
//* GET Section Cookies
export const getTokenFromCookie = () => {
  const accessToken = Cookies.get("accessToken");
  if (accessToken) return accessToken;
  return null;
};

export const getImageProfileFromCookie = () => {
  const image = Cookies.get("image");
  if (image) return image;
  return null;
};
export const getAddressIdFromCookie = () => {
  const addressId = Cookies.get("addressId");
  if (addressId) return addressId;
  return null;
};

export const getPhoneFromCookie = () => {
  const phone = Cookies.get("phone");
  if (phone) return phone;
  return null;
};

export const getAmoutFromCookie = () => {
  const amount = Cookies.get("amount");
  if (amount) return amount;
  return null;
};

export const getUserIdFromCookie = () => {
  const userId = Cookies.get("userId");
  if (userId) return userId;
  return null;
};

export const getFullNameFromCookie = () => {
  const fullName = Cookies.get("fullName");
  if (fullName) return fullName;
  return null;
};

export const getCart = () => {
  return Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : [];
};

//* SET Section Cookeis
export const SetCookie_Token = (access) => {
  Cookies.set("accessToken", access, { expires: 29 });
};
export const setFullNameCookie = (fullName) => {
  Cookies.set("fullName", fullName, { expires: 29 });
};
export const SetCookie_Phone = (phone) => {
  Cookies.set("phone", phone, { expires: 29 });
};
export const setImageUrlCookie = (img) => {
  Cookies.set("image", img, { expires: 29 });
};
export const setAddressIdCookie = (addressId) => {
  Cookies.set("addressId", addressId, { expires: 29 });
};
export const setAmountCookie = (amount) => {
  Cookies.set("amount", amount, { expires: 0.5 });
};
export const setUserIdCookie = (userId) => {
  Cookies.set("userId", userId, { expires: 0.5 });
};
export const addToCartCookie = (productId, quantity, quanityAllProduct) => {
  let cart = Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : [];

  const existingProduct = cart.find((item) => item.id === productId);
  if (existingProduct) {
    if (existingProduct.quantity + quantity > quanityAllProduct)
      return {
        isSuccess: false,
        message: "حداکثر تعداد سفارش",
      };
    else existingProduct.quantity += quantity;
  } else cart.push({ id: productId, quantity });

  Cookies.set("cart", JSON.stringify(cart), { expires: 7 });
  return {
    isSuccess: true,
    message: "",
  };
};

//* Clear Cookie
export const clearCookie = () => {
  const allCookies = Cookies.get();
  for (let cookie in allCookies) {
    Cookies.remove(cookie);
  }
};

export const removeFromCart = (productId) => {
  let cart = Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : [];
  cart = cart.filter((item) => item.id !== productId);

  Cookies.set("cart", JSON.stringify(cart), { expires: 7 });
};
